import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col-12" }
const _hoisted_3 = { class: "p-float-label" }
const _hoisted_4 = {
  for: "sparqlEndpoint",
  class: "kn-material-input-label"
}
const _hoisted_5 = { class: "p-field p-col-6" }
const _hoisted_6 = { class: "p-float-label" }
const _hoisted_7 = {
  for: "sparqlDefaultGraphIri",
  class: "kn-material-input-label"
}
const _hoisted_8 = { class: "p-field p-col-6" }
const _hoisted_9 = { class: "p-float-label" }
const _hoisted_10 = {
  for: "sparqlExecutionTimeout",
  class: "kn-material-input-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_VCodeMirror = _resolveComponent("VCodeMirror")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, { class: "p-m-2" }, {
    content: _withCtx(() => [
      _createVNode("form", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("span", _hoisted_3, [
            _createVNode(_component_InputText, {
              id: "sparqlEndpoint",
              class: ["kn-material-input", {
                                'p-invalid': _ctx.v$.dataset.sparqlEndpoint.$invalid && _ctx.v$.dataset.sparqlEndpoint.$dirty
                            }],
              type: "text",
              modelValue: _ctx.v$.dataset.sparqlEndpoint.$model,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.dataset.sparqlEndpoint.$model = $event)),
              modelModifiers: { trim: true },
              onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.dataset.sparqlEndpoint.$touch())),
              onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('touched')))
            }, null, 8, ["modelValue", "class"]),
            _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('managers.datasetManagement.sparqlEndpoint')) + " * ", 1)
          ]),
          _createVNode(_component_KnValidationMessages, {
            class: "p-mt-1",
            vComp: _ctx.v$.dataset.sparqlEndpoint,
            additionalTranslateParams: { fieldName: _ctx.$t('managers.datasetManagement.sparqlEndpoint') }
          }, null, 8, ["vComp", "additionalTranslateParams"])
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode("span", _hoisted_6, [
            _createVNode(_component_InputText, {
              id: "sparqlDefaultGraphIri",
              class: "kn-material-input",
              modelValue: _ctx.dataset.sparqlDefaultGraphIri,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.dataset.sparqlDefaultGraphIri = $event)),
              modelModifiers: { trim: true },
              onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('touched')))
            }, null, 8, ["modelValue"]),
            _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('managers.datasetManagement.sparqlDefaultGraphIri')), 1)
          ])
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode("span", _hoisted_9, [
            _createVNode(_component_InputText, {
              id: "sparqlExecutionTimeout",
              class: "kn-material-input",
              type: "number",
              modelValue: _ctx.dataset.sparqlExecutionTimeout,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.dataset.sparqlExecutionTimeout = $event)),
              modelModifiers: { trim: true },
              onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('touched')))
            }, null, 8, ["modelValue"]),
            _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('managers.datasetManagement.sparqlExecutionTimeout')), 1)
          ])
        ])
      ]),
      _createVNode(_component_VCodeMirror, {
        class: "p-mt-2",
        ref: "codeMirrorSparql",
        value: _ctx.dataset.sparqlQuery,
        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => (_ctx.dataset.sparqlQuery = $event)),
        autoHeight: true,
        options: _ctx.sparqlOptions,
        onKeyup: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('touched')))
      }, null, 8, ["value", "options"])
    ]),
    _: 1
  }))
}